function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { createRef } from "react";
import SocialTopics from "../containers/SocialTopics";
import SocialActivityEditor from "../containers/SocialActivityEditor";
import SocialActivityDeletor from "../containers/SocialActivityDeletor";
import SocialTopic from "./SocialTopic";
import SocialSphereEditor from "../containers/SocialSphereEditor";
import SocialSphereSelector from "../containers/SocialSphereSelector";
import SocialAppModal from "./SocialAppModal.react.js";
import SocialAppHeader from "./SocialAppHeader";
import SocialAppFooter from "./SocialAppFooter";
import SocialMemberBubble from "../containers/SocialMemberBubble";
import SocialAPIUtils from "../utils/SocialAPIUtils";
import ErrorBoundary from "./ErrorBoundary";
import Icon from "./Icon";
import { EventEmitter } from "events";
import { find, map, uniq, isEqual } from "lodash";
import { CSSTransition } from "react-transition-group";
import { FocusOn } from "react-focus-on";
import { injectIntl } from "react-intl";
import { getGroupLabel } from "../utils/SocialGroupsUtils";
import { getAllTopicsChronologically } from "../utils/SocialTopicsUtils";
import { getConnectionStatus } from "../utils/SocialConnectionsUtils";
import eventBus from "../utils/eventBus";
import UIToggleButton from "./ui/UIToggleButton";
// Constants
var VIEW_SIGNED_OUT = "SIGNED OUT";
var VIEW_HOME = "HOME";
var VIEW_TOPICS = "TOPICS";
var VIEW_ACTIVITIES = "ACTIVITIES";
var MODAL_SPHERE = "SPHERE EDITOR";
var MODAL_SPHERE_INFO = "SPHERE INFO";
var MODAL_TOPIC = "TOPIC EDITOR";
var MODAL_ACTIVITY = "ACTIVITY EDITOR";
var MODAL_ACTIVITY_DELETE = "ACTIVITY DELETE";
var MODAL_DISCLAIMER = "DISCLAIMER";
var NODE_FILTER_TYPES = {
    CBOOK: "cbook",
    CURRENT_CHART: "current_chart"
};
var SocialApp = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    _inherits(SocialApp, _React_Component);
    var _super = _createSuper(SocialApp);
    function SocialApp(props) {
        _classCallCheck(this, SocialApp);
        var _this;
        _this = _super.call(this, props);
        _this.renderTopics = function() {
            var _this_state = _this.state, selectedSphere = _this_state.selectedSphere, isGroupManagementAllowed = _this_state.isGroupManagementAllowed, currentOnly = _this_state.currentOnly;
            var intl = _this.props.intl;
            var label = selectedSphere ? getGroupLabel(selectedSphere, intl.formatMessage({
                id: "social.activities.me",
                defaultMessage: "Myself"
            })) : "";
            return {
                body: selectedSphere ? /*#__PURE__*/ React.createElement(SocialTopics, {
                    className: "social-app-body__wrapper",
                    sphere: selectedSphere,
                    isGroupManagementAllowed: isGroupManagementAllowed,
                    onCreate: _this._onCreateTopic,
                    onEdit: _this._onEditSphere,
                    onSelect: _this._onSelectTopic,
                    selectTopic: _this.props.selectTopic,
                    selectNote: _this.props.selectNote
                }) : null,
                header: {
                    content: /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("ul", {
                        className: "social-breadcrumb social-breadcrumb--max"
                    }, /*#__PURE__*/ React.createElement("li", {
                        className: "social-breadcrumb__item"
                    }, /*#__PURE__*/ React.createElement("button", {
                        className: "social-breadcrumb__link",
                        onClick: _this._onHome,
                        "aria-label": intl.formatMessage({
                            id: "social.activities.title",
                            defaultMessage: "My communities"
                        })
                    }, /*#__PURE__*/ React.createElement(Icon, {
                        name: "social-breadcrumb-home",
                        size: "m"
                    }))), /*#__PURE__*/ React.createElement(Icon, {
                        name: "chevron-right",
                        size: "s",
                        className: "social-breadcrumb__separator"
                    }), /*#__PURE__*/ React.createElement("li", {
                        className: "social-breadcrumb__item"
                    }, label)), _this.renderToggle())
                }
            };
        };
        _this.renderActivities = function() {
            var _this_props_session;
            var intl = _this.props.intl;
            var _this_state = _this.state, selectedTopic = _this_state.selectedTopic, selectedSphere = _this_state.selectedSphere;
            var isEditable = ((_this_props_session = _this.props.session) === null || _this_props_session === void 0 ? void 0 : _this_props_session.id) === (selectedTopic === null || selectedTopic === void 0 ? void 0 : selectedTopic.owner.id);
            return {
                body: /*#__PURE__*/ React.createElement(SocialTopic, {
                    className: "social-app-body__wrapper",
                    topic: selectedTopic,
                    onNewAnswer: _this._onShowActivityEditor,
                    onEditTopic: _this._onEditTopic,
                    onDeleteTopic: null,
                    onEditActivity: _this._onShowActivityEditor,
                    onDeleteActivity: _this._onShowActivityDelete,
                    isEditable: isEditable,
                    session: _this.props.session
                }),
                header: {
                    content: /*#__PURE__*/ React.createElement("ul", {
                        className: "social-breadcrumb"
                    }, /*#__PURE__*/ React.createElement("li", {
                        className: "social-breadcrumb__item"
                    }, /*#__PURE__*/ React.createElement("button", {
                        className: "social-breadcrumb__link",
                        onClick: _this._onHome,
                        "aria-label": intl.formatMessage({
                            id: "social.activities.title",
                            defaultMessage: "My communities"
                        })
                    }, /*#__PURE__*/ React.createElement(Icon, {
                        name: "social-breadcrumb-home",
                        size: "m"
                    }))), /*#__PURE__*/ React.createElement(Icon, {
                        name: "chevron-right",
                        size: "s",
                        className: "social-breadcrumb__separator"
                    }), /*#__PURE__*/ React.createElement("li", {
                        className: "social-breadcrumb__item"
                    }, /*#__PURE__*/ React.createElement("button", {
                        className: "social-breadcrumb__link",
                        onClick: _this._onTopics,
                        "aria-label": intl.formatMessage({
                            id: "social.activities.all_topics_on_community",
                            defaultMessage: "All topics on this community"
                        })
                    }, /*#__PURE__*/ React.createElement(SocialMemberBubble, {
                        members: (selectedSphere === null || selectedSphere === void 0 ? void 0 : selectedSphere.members) || []
                    }))), /*#__PURE__*/ React.createElement(Icon, {
                        name: "chevron-right",
                        size: "s",
                        className: "social-breadcrumb__separator"
                    }), /*#__PURE__*/ React.createElement("li", {
                        className: "social-breadcrumb__item"
                    }, selectedTopic === null || selectedTopic === void 0 ? void 0 : selectedTopic.title))
                }
            };
        };
        _this.renderToggle = function() {
            var _this_props = _this.props, intl = _this_props.intl, currentOnly = _this_props.currentOnly;
            var showFromAllCBook = _this.state.currentNodeFilter === NODE_FILTER_TYPES.CBOOK;
            var currentFilter = showFromAllCBook ? intl.formatMessage({
                id: "social.activities._title_nodes_filter_cbook",
                defaultMessage: "cbook"
            }) : intl.formatMessage({
                id: "social.activities._title_nodes_filter_current_chart",
                defaultMessage: "current slide"
            });
            return !currentOnly && /*#__PURE__*/ React.createElement(UIToggleButton, {
                id: "filter-activity-center",
                onToggle: _this._onNodeFilterChanged,
                pressed: showFromAllCBook,
                label: intl.formatMessage({
                    id: "social.activities._title_nodes_filter_label",
                    defaultMessage: "Showing from: {currentFilter}"
                }, {
                    currentFilter: currentFilter
                })
            }, /*#__PURE__*/ React.createElement(Icon, {
                name: showFromAllCBook ? "pages-all" : "page-current",
                size: "m"
            }), /*#__PURE__*/ React.createElement("span", {
                className: "ui-toggle-text"
            }, currentFilter));
        };
        _this.renderHome = function() {
            var _this_state = _this.state, isGroupManagementAllowed = _this_state.isGroupManagementAllowed, isUserManagementAllowed = _this_state.isUserManagementAllowed, sphereFilter = _this_state.sphereFilter;
            var intl = _this.props.intl;
            return {
                body: /*#__PURE__*/ React.createElement(SocialSphereSelector, {
                    className: "social-app-body__wrapper",
                    isGroupManagementAllowed: isGroupManagementAllowed,
                    isUserManagementAllowed: isUserManagementAllowed,
                    filter: sphereFilter,
                    onSelect: _this._onSphereSelectionChanged,
                    onEdit: _this._onEditSphere,
                    onCreate: _this._onNewSphere
                }),
                header: {
                    content: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
                        className: "social-app-title",
                        id: "activity-center-header"
                    }, intl.formatMessage({
                        id: "social.activities.title",
                        defaultMessage: "Title"
                    })), _this.renderToggle()),
                    hero: true
                }
            };
        };
        _this.renderSignedOut = function() {
            var _this_state = _this.state, isUserManagementAllowed = _this_state.isUserManagementAllowed, connectionIsOffline = _this_state.connectionIsOffline;
            var intl = _this.props.intl;
            var status = getConnectionStatus("tweet");
            var isError = status > 399;
            return {
                header: {
                    content: /*#__PURE__*/ React.createElement("div", {
                        className: "social-app__error-header"
                    }, isError ? intl.formatMessage({
                        id: "social.activities.errorHeader",
                        defaultMessage: "Error status {status}"
                    }, {
                        status: status
                    }) : intl.formatMessage({
                        id: "social.activities._signed_out",
                        defaultMessage: "Signed Out!"
                    }))
                },
                body: /*#__PURE__*/ React.createElement("div", {
                    className: "social-app__signed-out"
                }, !!isUserManagementAllowed && !connectionIsOffline ? /*#__PURE__*/ React.createElement("p", null, status > 403 ? intl.formatMessage({
                    id: "social.activities.errorMsg",
                    defaultMessage: "Error status {status}"
                }, {
                    status: status
                }) : intl.formatMessage({
                    id: "social.activities._signed_out",
                    defaultMessage: "Signed Out"
                })) : connectionIsOffline ? /*#__PURE__*/ React.createElement("p", null, intl.formatMessage({
                    id: "social.activities._server_offline",
                    defaultMessage: "Server Offline"
                })) : /*#__PURE__*/ React.createElement("p", null, intl.formatMessage({
                    id: "social.activities._user_management_disabled",
                    defaultMessage: "User Management Disabled"
                })))
            };
        };
        _this.getCurrentView = function(currentView) {
            var view;
            switch(currentView){
                case VIEW_SIGNED_OUT:
                    view = _this.renderSignedOut();
                    break;
                case VIEW_ACTIVITIES:
                    view = _this.renderActivities();
                    break;
                case VIEW_TOPICS:
                    view = _this.renderTopics();
                    break;
                default:
                    view = _this.renderHome();
                    break;
            }
            return view;
        };
        // =========================================================
        //        TOPICS SPECIFIC
        // =========================================================
        _this._onTopicChange = function() {
            var _this_props = _this.props, groups = _this_props.groups, topics = _this_props.topics;
            if (_this.state.selectedTopic) {
                _this.setState({
                    selectedTopic: topics[_this.state.selectedTopic.id] || null
                });
            } else {
                _this.setState({
                    sphereFilter: _this.state.currentNodeFilter === NODE_FILTER_TYPES.CBOOK ? map(groups, "id") : uniq(map(getAllTopicsChronologically(), "group_id"))
                });
            }
        };
        _this._onToggleCreateTopic = function(isEditing) {
            _this.setState({
                isCreatingTopic: isEditing
            });
        };
        _this._onSelectTopic = function(topic) {
            _this.setState({
                currentView: VIEW_ACTIVITIES,
                selectedTopic: topic
            });
        };
        _this._onSearchedTopicSelect = function(topic, app) {
            if (app === "Activity") {
                var group = topic ? find(_this.props.groups, function(group) {
                    return group.id === topic.group_id;
                }) : null;
                _this.searchTopic = true;
                _this.setState({
                    selectedSphere: group || null,
                    currentView: VIEW_ACTIVITIES,
                    selectedTopic: topic
                });
            }
        };
        _this._onEditTopic = function() {
            _this.setState({
                modalView: MODAL_TOPIC,
                editableTopic: _this.state.selectedTopic
            });
        };
        _this._onShowTopics = function() {
            _this.props.selectTopic(null);
            _this.setState({
                currentView: VIEW_TOPICS,
                selectedTopic: null
            });
        };
        _this._onShowActivityEditor = function(activity) {
            _this.setState({
                modalView: MODAL_ACTIVITY,
                editableActivity: activity || null
            });
        };
        _this._onShowActivityDelete = function(activity) {
            _this.setState({
                modalView: MODAL_ACTIVITY_DELETE,
                deletableActivity: activity || null
            });
        };
        _this._activityEditorAction = function(action) {
            return function() {
                _this.state.activityEditorAction.emit("action", action);
            };
        };
        _this._activityDeletorAction = function(action) {
            return function() {
                _this.state.activityDeletorAction.emit("action", action);
            };
        };
        _this._onCreateTopic = function() {
            _this.setState({
                modalView: MODAL_TOPIC
            });
        };
        _this._topicEditorAction = function(action) {
            return function() {
                _this.state.topicEditorAction.emit("action", action);
            };
        };
        _this._onNodeFilterChanged = function(filter) {
            var nodes = _this._getNodesForFilter(filter);
            _this._updateSearchFilter(_this.state.selectedSphere, nodes);
            _this.setState({
                currentNodeFilter: filter
            });
        };
        _this._getNodesForFilter = function(filterValue) {
            var currentSlide = _this.props.currentSlide;
            switch(filterValue){
                case NODE_FILTER_TYPES.CBOOK:
                    return [];
                case NODE_FILTER_TYPES.CURRENT_CHART:
                    return currentSlide ? [
                        currentSlide
                    ] : [];
                default:
                    return [];
            }
        };
        _this._updateSearchFilter = function(sphere, nodes) {
            _this.setState({
                selectedSphere: sphere,
                selectedCbookNodes: nodes
            });
        };
        // =========================================================
        //        SOCIAL SPHERE SPECIFIC
        // =========================================================
        // Spheres are groups, in case you didn't know.
        _this._onSphereSelectionChanged = function(sphere) {
            _this._updateSearchFilter(sphere, _this.state.selectedCbookNodes);
            _this.setState({
                currentView: VIEW_TOPICS
            });
        };
        _this._onEditSphere = function(sphere) {
            var isInfoView = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            _this.setState({
                modalView: isInfoView === true ? MODAL_SPHERE_INFO : MODAL_SPHERE,
                editableSphere: sphere
            });
        };
        _this._onNewSphere = function() {
            _this.setState({
                modalView: MODAL_SPHERE,
                editableSphere: null
            });
        };
        _this._onToggleSphereSelection = function() {
            _this.setState({
                isSelectingSpheres: !_this.state.isSelectingSpheres,
                isEditingSphere: false,
                isCreatingTopic: false
            });
        };
        _this._onGroupsLoaded = function() {
            var nodes = _this._getNodesForFilter(_this.state.currentNodeFilter);
            _this._updateSearchFilter(_this.state.selectedSphere, nodes);
        };
        _this._sphereEditorAction = function(action) {
            return function() {
                return _this.state.sphereEditorAction.emit("action", action);
            };
        };
        // =========================================================
        //        APP SPECIFIC
        // =========================================================
        _this._onConfigChange = function() {
            var _this_props = _this.props, student = _this_props.student, sendDebugMessage = _this_props.sendDebugMessage;
            sendDebugMessage("Configuration loaded", "success", "Engagement Server");
            if (student && student.id && student.id) {
                SocialAPIUtils.createTokenBasedSession(student);
            }
        };
        _this._onSessionChange = function() {
            var _this_props = _this.props, sendDebugMessage = _this_props.sendDebugMessage, session = _this_props.session, socialConfig = _this_props.socialConfig, isLoggedIn = _this_props.isLoggedIn;
            if (isLoggedIn) {
                if ((socialConfig === null || socialConfig === void 0 ? void 0 : socialConfig.disclaimer.needs_endorsement) && (session === null || session === void 0 ? void 0 : session.is_disclaimer_endorsed) || !(socialConfig === null || socialConfig === void 0 ? void 0 : socialConfig.disclaimer.needs_endorsement)) {
                    // the disclaimer has been accepted OR there is no disclaimer that needs accepting - we are good to go!
                    sendDebugMessage("Logged in successfully", "success", "Engagement Server");
                    _this.setState({
                        // If the currentView has previously been the "signed out" screen, set it to home since the user is now logged in.
                        // Otherwise leave the view as it was in order to not throw the user out of the view they were currently using.
                        currentView: _this.state.currentView === VIEW_SIGNED_OUT ? VIEW_HOME : _this.state.currentView,
                        modalView: null
                    });
                } else {
                    // user is logged in, but hasn't accepted the disclaimer yet
                    sendDebugMessage("The disclaimer must be accepted before using the social features!", "warning", "");
                    _this.setState({
                        modalView: MODAL_DISCLAIMER,
                        currentView: VIEW_SIGNED_OUT
                    });
                }
            } else {
                // user is not logged in yet
                _this.setState({
                    currentView: VIEW_SIGNED_OUT,
                    modalView: null
                });
            }
        };
        _this._onToggleSocialApp = function() {
            return function(evnt) {
                evnt.preventDefault();
                evnt.stopPropagation();
                evnt.currentTarget.blur();
                _this.props.close();
            };
        };
        _this._cancelModal = function() {
            _this.setState({
                modalView: null,
                editableSphere: null,
                editableTopic: null
            });
        };
        _this._onTopics = function(evnt) {
            evnt.preventDefault();
            _this._onShowTopics();
        };
        _this._onHome = function(evnt) {
            evnt.preventDefault();
            _this.setState({
                selectedSphere: null,
                selectedTopic: null,
                modalView: null,
                editableSphere: null,
                editableTopic: null,
                currentView: VIEW_HOME
            });
        };
        _this._onConnectionUpdate = function(connection) {
            // TODO: make sensible messages, what happens for each status code?
            var _this_props = _this.props, sendDebugMessage = _this_props.sendDebugMessage, logError = _this_props.logError;
            if (!connection) {
                return;
            }
            var status = getConnectionStatus("tweet");
            sendDebugMessage("Engagement Server Status: " + status, status > 220 ? "error" : "info", "");
            if (status >= 300) {
                logError("Fehler beim Laden von Content: Status " + status, "engagement_server_connection_error");
            } else if (status === 0 && !_this.state.connectionIsOffline) {
                logError("Verbindung zum Engagement Server unterbrochen", "engagement_server_offline");
                _this.setState({
                    connectionIsOffline: true
                });
            }
            if (status > 0) {
                _this.setState({
                    connectionIsOffline: false,
                    currentView: status > 399 && _this.state.currentView !== VIEW_SIGNED_OUT ? VIEW_SIGNED_OUT : _this.state.currentView
                });
            }
        };
        _this._acceptDisclaimer = function(evnt) {
            evnt.preventDefault();
            _this.props.acceptDisclaimer();
        };
        _this.closeButton = /*#__PURE__*/ createRef();
        _this.searchTopic = false;
        _this.state = {
            currentView: VIEW_SIGNED_OUT,
            modalView: null,
            currentOnly: false,
            connectionIsOffline: false,
            // Sphere Selection specifics
            selectedSphere: null,
            sphereFilter: null,
            editableSphere: null,
            editableActivity: null,
            editableTopic: null,
            deletableActivity: null,
            selectedTopic: null,
            isEditingSphere: false,
            isSelectingSpheres: false,
            isCreatingTopic: false,
            sphereEditorAction: new EventEmitter(),
            topicEditorAction: new EventEmitter(),
            activityEditorAction: new EventEmitter(),
            activityDeletorAction: new EventEmitter(),
            // Node Selection:
            currentNodeFilter: NODE_FILTER_TYPES.CBOOK,
            selectedCbookNodes: [],
            isGroupManagementAllowed: true,
            isUserManagementAllowed: true
        };
        return _this;
    }
    var _proto = SocialApp.prototype;
    _proto.componentDidMount = function componentDidMount() {
        eventBus.register("Escape", "social-app", this.props.close);
        if (this.props.connections.tweet) {
            this._onConnectionUpdate(this.props.connections.tweet);
        }
        if (this.props.session) {
            this._onSessionChange();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.sphereEditorAction.removeAllListeners();
        this.state.topicEditorAction.removeAllListeners();
        this.state.activityEditorAction.removeAllListeners();
        this.state.activityDeletorAction.removeAllListeners();
        eventBus.unregister("Escape", "social-app");
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var _this_props = this.props, visible = _this_props.visible, currentSlide = _this_props.currentSlide, currentOnly = _this_props.currentOnly, socialConfig = _this_props.socialConfig, session = _this_props.session, isLoadingGroups = _this_props.isLoadingGroups, isLoggedIn = _this_props.isLoggedIn, topics = _this_props.topics, connections = _this_props.connections, currentSearch = _this_props.currentSearch, groups = _this_props.groups, isCreatingGroup = _this_props.isCreatingGroup;
        if (!isEqual(prevProps.currentSearch, currentSearch)) {
            this._onSearchedTopicSelect(currentSearch.topic, currentSearch.app);
        }
        if (prevProps.currentSlide !== currentSlide && isLoggedIn) {
            var nodes = this._getNodesForFilter(this.state.currentNodeFilter);
            this._updateSearchFilter(this.state.selectedSphere, nodes);
        }
        if (currentOnly !== prevProps.currentOnly && currentOnly) {
            this.setState({
                currentNodeFilter: NODE_FILTER_TYPES.CURRENT_CHART
            });
        }
        if (prevProps.visible !== visible && visible) {
            eventBus.setScope("social-app");
        }
        if (prevProps.visible !== visible && !visible) {
            eventBus.usePrevScope();
        }
        if (!isEqual(prevProps.socialConfig, socialConfig)) {
            this._onConfigChange();
        }
        if (!isEqual(prevProps.session, session)) {
            this._onSessionChange();
        }
        // check if groups have been loaded
        if (prevProps.isLoadingGroups && !isLoadingGroups) {
            this._onGroupsLoaded();
        }
        if (!isEqual(prevProps.topics, topics)) {
            this._onTopicChange();
        }
        if (!isEqual(prevProps.connections, connections) && connections.tweet) {
            this._onConnectionUpdate(connections.tweet);
        }
        if (prevProps.isCreatingGroup && !isCreatingGroup && !isEqual(prevProps.groups, groups)) {
            this.setState({
                modalView: null,
                currentView: VIEW_HOME
            });
        }
        if (!prevProps.visible && !!visible && isLoggedIn) {
            this.props.fetchGroups();
            this.props.fetchUsers();
        }
        // ipad tinymce fix
        if (!visible && !!document.activeElement && !!document.activeElement.blur) {
            document.activeElement.blur();
            window.focus();
        }
        // reload topics if:
        // - selected sphere has changed
        // - is visible has changed
        // - selected cBook Nodes have changed
        // - modal view has changed and is now falsy
        if (!!prevProps.isLoggedIn && (!isEqual(this.state.selectedSphere, prevState.selectedSphere) || !isEqual(visible, prevProps.visible) || !isEqual(this.state.selectedCbookNodes, prevState.selectedCbookNodes) || !isEqual(this.state.modalView, prevState.modalView) && !this.state.modalView)) {
            var newGroups = this.state.selectedSphere ? [
                this.state.selectedSphere
            ] : groups;
            this.props.fetchTopics({
                spheres: newGroups,
                nodes: map(this.state.selectedCbookNodes, function(nodeId) {
                    return {
                        id: nodeId
                    };
                })
            });
        }
        if (prevProps.isAcceptingDisclaimer !== this.props.isAcceptingDisclaimer && !this.props.isAcceptingDisclaimer && !this.props.acceptDisclaimerError) {
            this._onSessionChange();
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _this_state = this.state, modalView = _this_state.modalView, currentView = _this_state.currentView, sphereEditorAction = _this_state.sphereEditorAction, editableSphere = _this_state.editableSphere, editableTopic = _this_state.editableTopic, selectedSphere = _this_state.selectedSphere, topicEditorAction = _this_state.topicEditorAction, editableActivity = _this_state.editableActivity, deletableActivity = _this_state.deletableActivity, selectedTopic = _this_state.selectedTopic, activityEditorAction = _this_state.activityEditorAction, activityDeletorAction = _this_state.activityDeletorAction;
        var _this_props = this.props, intl = _this_props.intl, shareable = _this_props.shareable, cbook = _this_props.cbook, close = _this_props.close, visible = _this_props.visible, socialConfig = _this_props.socialConfig;
        var disclaimer = socialConfig === null || socialConfig === void 0 ? void 0 : socialConfig.disclaimer;
        var view = this.getCurrentView(currentView);
        var modalBody;
        switch(modalView){
            case MODAL_SPHERE:
            case MODAL_SPHERE_INFO:
                {
                    modalBody = /*#__PURE__*/ React.createElement(SocialSphereEditor, {
                        action: sphereEditorAction,
                        sphere: editableSphere,
                        onChange: this._cancelModal,
                        isInfoView: modalView === MODAL_SPHERE_INFO
                    });
                    var leftButton;
                    var rightButton;
                    if (modalView === MODAL_SPHERE_INFO) {
                        leftButton = {
                            title: intl.formatMessage({
                                id: "social.activities.back",
                                defaultMessage: "Back"
                            }),
                            action: this._cancelModal,
                            mode: "success"
                        };
                        rightButton = false;
                    } else {
                        leftButton = {
                            action: function() {
                                _this._sphereEditorAction("cancel")();
                                _this._cancelModal();
                            }
                        };
                        rightButton = {
                            action: this._sphereEditorAction("save")
                        };
                    }
                    view.header = {
                        content: editableSphere ? intl.formatMessage({
                            id: "social.activities.info_sphere",
                            defaultMessage: "Community Info"
                        }) : intl.formatMessage({
                            id: "social.activities.new_sphere",
                            defaultMessage: "New Community"
                        }),
                        buttons: {
                            leftButton: leftButton,
                            rightButton: rightButton
                        }
                    };
                    break;
                }
            case MODAL_TOPIC:
                modalBody = /*#__PURE__*/ React.createElement(SocialActivityEditor, {
                    sphere: selectedSphere,
                    isTopic: true,
                    activity: editableTopic ? editableTopic.description : {},
                    topic: editableTopic || {},
                    action: topicEditorAction,
                    onSaved: this._cancelModal,
                    sharedNote: shareable
                });
                view.header = {
                    content: editableTopic ? intl.formatMessage({
                        id: "social.activities.edit_topic",
                        defaultMessage: "edit Topic"
                    }) : intl.formatMessage({
                        id: "social.activities.new_topic",
                        defaultMessage: "new Topic"
                    }),
                    buttons: {
                        leftButton: {
                            action: this._cancelModal
                        },
                        rightButton: {
                            action: this._topicEditorAction("save")
                        }
                    }
                };
                break;
            case MODAL_ACTIVITY:
                modalBody = /*#__PURE__*/ React.createElement(SocialActivityEditor, {
                    height: 238,
                    isTopic: false,
                    activity: editableActivity || {},
                    topic: selectedTopic,
                    action: activityEditorAction,
                    onSaved: this._cancelModal
                });
                view.header = {
                    content: editableActivity ? intl.formatMessage({
                        id: "social.activities.edit_activity",
                        defaultMessage: "edit Activity"
                    }) : intl.formatMessage({
                        id: "social.activities.new_activity",
                        defaultMessage: "new Activity"
                    }),
                    buttons: {
                        leftButton: {
                            action: this._cancelModal
                        },
                        rightButton: {
                            action: this._activityEditorAction("save")
                        }
                    }
                };
                break;
            case MODAL_ACTIVITY_DELETE:
                modalBody = /*#__PURE__*/ React.createElement(SocialActivityDeletor, {
                    activity: deletableActivity || {},
                    topic: selectedTopic,
                    action: activityDeletorAction,
                    onDeleted: this._cancelModal
                });
                view.header = {
                    content: deletableActivity && intl.formatMessage({
                        id: "social.activities.delete_activity",
                        defaultMessage: "delete Activity"
                    }),
                    buttons: {
                        leftButton: {
                            action: this._cancelModal
                        },
                        rightButton: {
                            action: this._activityDeletorAction("delete")
                        }
                    }
                };
                break;
            case MODAL_DISCLAIMER:
                modalBody = /*#__PURE__*/ React.createElement("div", {
                    className: "social-app-disclaimer",
                    dangerouslySetInnerHTML: {
                        __html: cbook && (disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.languages[cbook.default_ui_language]) ? disclaimer.languages[cbook.default_ui_language] : ""
                    }
                });
                view.header = {
                    content: intl.formatMessage({
                        id: "social.activities.disclaimer",
                        defaultMessage: "Disclaimer"
                    }),
                    buttons: {
                        rightButton: {
                            action: this._acceptDisclaimer,
                            title: intl.formatMessage({
                                id: "social.activities.accept_disclaimer",
                                defaultMessage: "Accept"
                            })
                        }
                    }
                };
                break;
            default:
                break;
        }
        return /*#__PURE__*/ React.createElement(CSSTransition, {
            in: visible,
            timeout: 300,
            classNames: "social-app"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "social-app social-app--activity-center"
        }, /*#__PURE__*/ React.createElement(ErrorBoundary, null, /*#__PURE__*/ React.createElement(FocusOn, {
            enabled: visible,
            onActivation: function() {
                var _this_closeButton, _this_closeButton_current;
                return (_this_closeButton = _this.closeButton) === null || _this_closeButton === void 0 ? void 0 : (_this_closeButton_current = _this_closeButton.current) === null || _this_closeButton_current === void 0 ? void 0 : _this_closeButton_current.focus();
            },
            className: "social-app-wrapper",
            noIsolation: true,
            autoFocus: true
        }, /*#__PURE__*/ React.createElement("button", {
            className: "close-btn",
            onClick: close,
            ref: this.closeButton,
            "aria-label": intl.formatMessage({
                id: "ui.close_dialog",
                defaultMessage: "Close dialog"
            })
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "close-socialmenu",
            size: "s"
        })), /*#__PURE__*/ React.createElement(SocialAppHeader, {
            hero: view.header.hero
        }, view.header.content), /*#__PURE__*/ React.createElement("div", {
            className: "social-app-body",
            "aria-hidden": !!modalView
        }, view.body), /*#__PURE__*/ React.createElement(SocialAppModal, {
            visible: !!modalView
        }, modalBody), /*#__PURE__*/ React.createElement(SocialAppFooter, {
            hero: view.header.hero,
            buttons: view.header.buttons
        }, view.header.content)))));
    };
    return SocialApp;
}(React.Component);
export default injectIntl(SocialApp);
